import { useContext } from 'react';

import PageContext from '../context/page.js';

export default function usePageContext() {
	let value = useContext(PageContext);

	return value;
}
